import React, { useState, useEffect } from "react";
import Bookingdetails1 from "./Bookingsdetails1";
import { TextField } from "@mui/material";
import formatDateAndTime from "../../common/formatDateAndTime";
import toast from "react-hot-toast";
import InfoIcon from "@mui/icons-material/Info";
import moment from "moment/moment";
import { BlinkBlur } from "react-loading-indicators";
import UseOnlineStatus from "../../common/UseOnlineStatus";

const Extension = ({
  summaryDetails,
  vehicleDetails,
  paymentDetailsData,
  getBookingDetail,
  setActiveTab,
  selectedRow,
  cities,
  bookingExtensionDetails,
}) => {
  const { isOnline, isSlowConnection } = UseOnlineStatus();
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const token = localStorage.getItem("token");
  const [affectedBookings, setAffectedBookings] = useState([]);
  const [costcalulator, setcostcalulator] = useState(null);
  const fleetBookingStatus = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.fleetBookingStatus;
  const paymentCollectionType = JSON.parse(
    localStorage.getItem("catalogValues"),
  )?.paymentCollectionType;
  delete paymentCollectionType?.inverted;
  const profile = JSON.parse(localStorage.getItem("profile"));
  const [paymentSavedDetails, setPaymentSavedDetails] = useState(null);
  const [selectedPaymentType, setSelectedPaymentType] = useState("");
  const [inputData, setInputData] = useState({});
  const [transactiondetails, settransactiodetails] = useState({
    transactionid: "",
    transactioncharges: "",
    paymentmode: "",
    payableamount: "",
    paymentremarks: "",
    attachments: null,
  });
  const [selectedFile, setSelectedFile] = useState(null);
  const [paymentLink, setPaymentLink] = useState(null);
  const [errors, setErrors] = useState({});
  const [paymentTypeErrors, setPaymentTypeErrors] = useState("");
  const [loading, setLoading] = useState(false);
  const [paymentLinkGenerated, setPaymentLinkGenerated] = useState(false);

  const hasUnstableConnection = !isOnline || isSlowConnection;

  const showNetworkAlert = () => {
    setPaymentLinkGenerated(false);
    toast.error(
      "Please check your network connection. Your internet connection appears to be unstable.",
      {
        position: "bottom-center",
        style: {
          background: "white",
          color: "red",
          fontWeight: "medium",
          marginBottom: "20px",
        },
      },
    );
  };

  function formatDate(inputDate) {
    if (!inputDate) return "";
    return moment(inputDate, "YYYY-MM-DD HH:mm:ss").format("YYYY-MM-DD");
  }

  function formatTime(inputDate) {
    if (!inputDate) return "";
    return moment(inputDate).format("HH:mm");
  }

  const extensionDetailsInput = [
    {
      label: "Start Date",
      type: "date",
      isEnable: true,
      value: "startDate",
      defaultValue: formatDate(summaryDetails?.bookTo),
    },
    {
      label: "Start Time",
      type: "time",
      isEnable: true,
      value: "startTime",
      defaultValue: formatTime(summaryDetails?.bookTo),
    },
    {
      label: "End Date",
      type: "date",
      isEnable: false,
      value: "endDate",
      defaultValue: "",
    },
    {
      label: "End Time",
      type: "time",
      isEnable: false,
      value: "endTime",
      defaultValue: "",
    },
  ];

  const transactionDetailsInput = [
    {
      label: "Transaction Id",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactionid",
    },
    {
      label: "Transaction Charges",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "transactioncharges",
    },
    {
      label: "Payment Mode",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentmode",
    },
    {
      label: "Payable Amount",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "payableamount",
    },
    {
      label: "Payment Remarks",
      type: "text",
      isEnable: false,
      placeholder: "",
      value: "paymentremarks",
    },
    {
      label: "Attachments",
      type: "file",
      isEnable: false,
      placeholder: "",
      value: "attachments",
    },
  ];

  useEffect(() => {
    const defaults = {};
    extensionDetailsInput.forEach((item) => {
      defaults[item.value] = item.defaultValue || "";
    });
    setInputData(defaults);
  }, [summaryDetails]); // re-run when summaryDetails changes

  const getAffectedBookings = async () => {
    try {
      const response = await fetch(
        `${apiUrl}/api/bookings/getbookingbydates?startDate=${
          inputData?.startDate + "T" + inputData?.startTime
        }&endDate=${inputData?.endDate + "T" + inputData?.endTime}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        },
      );
      const data = await response.json();
      if (data?.statusCode === "0100") {
        const filtered = data?.dataValues?.filter(
          (item) => String(item.vehicleId) === String(vehicleDetails?.id),
        );
        setAffectedBookings(filtered);
      }
      return data;
    } catch (error) {
      return console.error("Error fetching Affected Bookings:", error);
    }
  };

  const extensionCostCalculator = async () => {
    setLoading(true);
    try {
      let query = "";

      if (inputData?.startDate && inputData?.startTime) {
        query += `startDate=${inputData.startDate}T${inputData.startTime}`;
      }

      if (inputData?.endDate && inputData?.endTime) {
        query += `&endDate=${inputData.endDate}T${inputData.endTime}`;
      }

      if (summaryDetails?.packageDetails) {
        query += `&groupId=61`;
        query += `&packageId=${summaryDetails.packageDetails}`;
      }

      if (
        summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
        summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
        summaryDetails?.packageSelectedKey === "dailyRateMonthly"
      ) {
        query += `&bookingId=${summaryDetails?.id}`;
      }

      query += `&isPeakSeasons=false`;
      query += `&discountPercentage=0`;

      // Dynamic API endpoint
      const apiEndpoint =
        summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
        summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
        summaryDetails?.packageSelectedKey === "dailyRateMonthly"
          ? `${apiUrl}/api/subscriptionbookings/rent-calculator`
          : `${apiUrl}/api/booking/costcalulator`;

      const response = await fetch(`${apiEndpoint}?${query}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setcostcalulator(data?.dataValues);
      } else {
        setLoading(false);
        toast.error(data?.msg || data?.message, {
          position: "bottom-center",
          style: {
            background: "red",
            color: "white",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
      }
      return data;
    } catch (error) {
      return console.error("Error fetching extensionCostCalculator:", error);
    }
  };

  const handleSave = async () => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    let isValid = true;
    const newErrors = {};

    // Required fields
    const requiredFields = [
      "transactionid",
      "transactioncharges",
      "paymentmode",
      "payableamount",
      "paymentremarks",
      "attachments",
    ];

    requiredFields.forEach((field) => {
      if (!transactiondetails[field]) {
        newErrors[field] = "* Required";
        isValid = false;
      } else {
        const valid = validateField(field, transactiondetails[field]);
        if (!valid) isValid = false;
      }
    });

    setErrors(newErrors);

    if (!isValid) {
      toast.error("Please fix errors before submitting payment details");
      return;
    }

    toast.loading("Processing... Please wait", {
      id: "transaction", // same ID to update later
      position: "bottom-center",
    });

    try {
      const response = await fetch(`${apiUrl}/api/bookingtransactions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify({
          amount: transactiondetails?.payableamount,
          paymentMode: transactiondetails?.paymentmode,
          transactionCode: transactiondetails?.transactionid,
          transactionalCharges: transactiondetails?.transactioncharges,
          bookingId: summaryDetails?.id,
          description: transactiondetails?.paymentremarks,
          attachments: transactiondetails?.attachments
            ? JSON.stringify(transactiondetails.attachments)
            : null,
        }),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("transaction");
        toast.success(
          "Payment details added successfully. Click update booking to confirm the process.",
          {
            position: "bottom-center",
            style: {
              background: "blue", // override background
              color: "white",
              fontWeight: "medium",
              marginBottom: "20px",
            },
          },
        );
        settransactiodetails({
          transactionid: "",
          transactioncharges: "",
          paymentmode: "",
          payableamount: "",
          paymentremarks: "",
        });
        setPaymentSavedDetails(data?.dataValues);
        // getBookingDetail(selectedRow?.bookingCode, "booking");
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error,
      );
    }
  };

  const generatepaymentlink = async (type) => {
    if (hasUnstableConnection) {
      showNetworkAlert();
      return;
    }

    setPaymentLinkGenerated(true);
    let payload;

    if (type === "generate") {
      payload = {
        bookingId: summaryDetails?.bookingId,
        amount: Number(
          (
            calculateFinalAmount(costcalulator, paymentDetailsData)
              ?.finalAmount * 100
          ).toFixed(2),
        ),
        customerName: summaryDetails?.customerName,
        contactEmail: summaryDetails?.customerEmail,
        customerContact: summaryDetails?.customerMobile,
        customerId: summaryDetails?.customerId,
      };
    } else {
      payload = {
        paymentId: paymentLink?.paymentId,
        id: paymentLink?.id,
        bookingId: summaryDetails?.id,
        inquiryCode: summaryDetails?.inquiryCode,
      };
    }

    try {
      const response = await fetch(`${apiUrl}/api/paymentlinks`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setPaymentLinkGenerated(false);
        if (data?.dataValues?.status === "created") {
          toast.success("Payment link generated successfully.");
        } else {
          toast.success(
            "Payment Captured successfully. Click update booking to complete the process.",
          );
          // getBookingDetail(summaryDetails?.inquiryCode, "inquiry");
        }
        setPaymentLink(data?.dataValues);
      } else {
        setPaymentLinkGenerated(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setPaymentLinkGenerated(false);
      console.error("Error fetching generate payment link:", error);
    }
  };

  function formatDateforApi(dateString) {
    const date = new Date(dateString);
    return date.toISOString().slice(0, 16);
  }

  const updateBooking = async () => {
    const oldStartDate = formatDateforApi(summaryDetails?.bookFrom);
    const oldEndDate = formatDateforApi(summaryDetails?.bookTo);

    // toast.loading("Processing... Please wait", {
    //   id: "extension", // same ID to update later
    //   position: "bottom-center",
    // });

    let payload;
    if (selectedPaymentType === "Post Paid") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: paymentDetailsData?.id,
        bookingCode: paymentDetailsData?.bookingCode,
        weekdayRent: costcalulator?.weekdayRent,
        weekendRent: costcalulator?.weekendRent,
        weekDayHrs: costcalulator?.weekdayHrs,
        weekEndHrs: costcalulator?.weekendHrs,
        totalFreeKms: costcalulator?.totalFreeKms,
        totalHrs: costcalulator?.totalHrs,
        taxAmount: Number(
          calculateFinalAmount(costcalulator, paymentDetailsData)
            ?.taxCalculation,
        ),
        totalRentWithTax: Number(
          calculateFinalAmount(costcalulator, paymentDetailsData)?.finalAmount,
        ),
        startDate: inputData?.startDate + "T" + inputData?.startTime,
        endDate: inputData?.endDate + "T" + inputData?.endTime,
        oldStartDate: oldStartDate,
        oldEndDate: oldEndDate,
        paymentType: selectedPaymentType,
        bookingObject: {
          weekdayRent:
            paymentDetailsData?.weekdayRent + costcalulator?.weekdayRent,
          weekendRent:
            paymentDetailsData?.weekendRent + costcalulator?.weekendRent,
          weekdayHrs:
            paymentDetailsData?.weekdayHrs + costcalulator?.weekdayHrs,
          weekendHrs:
            paymentDetailsData?.weekendHrs + costcalulator?.weekendHrs,
          overallFreeKm:
            paymentDetailsData?.overallFreeKm + costcalulator?.totalFreeKms,
          taxAmount:
            paymentDetailsData?.taxAmount +
            Number(
              calculateFinalAmount(costcalulator, paymentDetailsData)
                ?.taxCalculation,
            ),
          id: paymentDetailsData?.id,
          costToCustomer:
            Number(paymentDetailsData?.costToCustomer) +
            Number(
              calculateFinalAmount(costcalulator, paymentDetailsData)
                ?.finalAmount,
            ),

          bookTo: inputData?.endDate + "T" + inputData?.endTime,
          bookingStatus: fleetBookingStatus?.inverted.bookingExtented,
          bookingHrs: paymentDetailsData?.bookingHrs + costcalulator?.totalHrs,
        },
        bookingHistory: {
          agentId: profile?.id,
          agentName: profile?.name,
          emailId: profile?.email,
          action: "Trip Extended",
          bookingId: paymentDetailsData?.id,
        },
      };
    } else if (selectedPaymentType === "Pre Paid") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: paymentDetailsData?.id,
        bookingCode: paymentDetailsData?.bookingCode,
        weekdayRent: costcalulator?.weekdayRent,
        weekendRent: costcalulator?.weekendRent,
        weekDayHrs: costcalulator?.weekdayHrs,
        weekEndHrs: costcalulator?.weekendHrs,
        totalFreeKms: costcalulator?.totalFreeKms,
        totalHrs: costcalulator?.totalHrs,
        taxAmount: Number(
          calculateFinalAmount(costcalulator, paymentDetailsData)
            ?.taxCalculation,
        ),
        totalRentWithTax: Number(
          calculateFinalAmount(costcalulator, paymentDetailsData)?.finalAmount,
        ),
        startDate: inputData?.startDate + "T" + inputData?.startTime,
        endDate: inputData?.endDate + "T" + inputData?.endTime,
        oldStartDate: oldStartDate,
        oldEndDate: oldEndDate,
        paymentType: selectedPaymentType,
        bookingObject: {
          weekdayRent:
            paymentDetailsData?.weekdayRent + costcalulator?.weekdayRent,
          weekendRent:
            paymentDetailsData?.weekendRent + costcalulator?.weekendRent,
          weekdayHrs:
            paymentDetailsData?.weekdayHrs + costcalulator?.weekdayHrs,
          weekendHrs:
            paymentDetailsData?.weekendHrs + costcalulator?.weekendHrs,
          overallFreeKm:
            paymentDetailsData?.overallFreeKm + costcalulator?.totalFreeKms,
          taxAmount:
            paymentDetailsData?.taxAmount +
            Number(
              calculateFinalAmount(costcalulator, paymentDetailsData)
                ?.taxCalculation,
            ),
          id: paymentDetailsData?.id,
          costToCustomer:
            Number(paymentDetailsData?.costToCustomer) +
            Number(
              calculateFinalAmount(costcalulator, paymentDetailsData)
                ?.finalAmount,
            ),

          bookTo: inputData?.endDate + "T" + inputData?.endTime,
          bookingStatus: fleetBookingStatus?.inverted.bookingExtented,
          bookingHrs: paymentDetailsData?.bookingHrs + costcalulator?.totalHrs,
        },
        bookingHistory: {
          agentId: profile?.id,
          agentName: profile?.name,
          emailId: profile?.email,
          action: "Trip Extended",
          bookingId: summaryDetails?.id,
        },
      };
    } else if (selectedPaymentType === "Freeze") {
      payload = {
        modifiedBy: profile?.id,
        bookingId: paymentDetailsData?.id,
        bookingCode: paymentDetailsData?.bookingCode,
        weekdayRent: costcalulator?.weekdayRent,
        weekendRent: costcalulator?.weekendRent,
        weekDayHrs: costcalulator?.weekdayHrs,
        weekEndHrs: costcalulator?.weekendHrs,
        totalFreeKms: costcalulator?.totalFreeKms,
        totalHrs: costcalulator?.totalHrs,
        taxAmount: Number(
          calculateFinalAmount(costcalulator, paymentDetailsData)
            ?.taxCalculation,
        ),
        totalRentWithTax: Number(
          calculateFinalAmount(costcalulator, paymentDetailsData)?.finalAmount,
        ),
        startDate: inputData?.startDate + "T" + inputData?.startTime,
        endDate: inputData?.endDate + "T" + inputData?.endTime,
        oldStartDate: oldStartDate,
        oldEndDate: oldEndDate,
        paymentType: selectedPaymentType,
        bookingObject: {
          id: paymentDetailsData?.id,
          bookTo: inputData?.endDate + "T" + inputData?.endTime,
          bookingStatus: fleetBookingStatus?.inverted?.bookingExtented,
          bookingHrs: paymentDetailsData?.bookingHrs + costcalulator?.totalHrs,
          overallFreeKm:
            paymentDetailsData?.overallFreeKm + costcalulator?.totalFreeKms,
        },
        bookingHistory: {
          agentId: profile?.id,
          agentName: profile?.name,
          emailId: profile?.email,
          action: "Trip Extended",
          bookingId: paymentDetailsData?.id,
        },
      };
    }
    // return;

    try {
      const response = await fetch(`${apiUrl}/api/dailyrentalextensions`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
        body: JSON.stringify(payload),
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        toast.dismiss("extension");
        toast.success("Booking Extension Details Updated.");
        setPaymentSavedDetails(data?.dataValues);
        getBookingDetail(summaryDetails?.inquiryCode, "inquiry");
        bookingExtensionDetails(summaryDetails?.id);
        // setActiveTab('trip')
      } else {
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return console.error(
        "Error fetching POST booking transaction initiate booking:",
        error,
      );
    }
  };

  useEffect(() => {
    if (costcalulator?.costToTheCustomer) {
      settransactiodetails((prev) => ({
        ...prev,
        payableamount: calculateFinalAmount(costcalulator, paymentDetailsData)
          ?.finalAmount,
      }));
    }
  }, [costcalulator]);

  const validateField = (key, value) => {
    let errorMsg = "";

    if (key === "transactioncharges" && !/^\d+$/.test(value)) {
      errorMsg = "* Accepts only numbers";
    }
    if (key === "payableamount" && !/^\d+(\.\d{1,2})?$/.test(value)) {
      errorMsg = "* Accepts only numbers (up to 2 decimals)";
    }
    if (key === "documentype" && !value) {
      errorMsg = "Please select a document type";
    }
    if (key === "paymentmode" && !/^[a-zA-Z]*$/.test(value)) {
      errorMsg = "* Accepts only alphabets";
    }
    if (key === "attachments" && !value) {
      errorMsg = "* Attachment required";
    }

    setErrors((prev) => ({ ...prev, [key]: errorMsg }));
    return errorMsg === "";
  };

  const handleInputChange = async (key, event) => {
    let value;

    if (event?.target?.type === "file") {
      value = event.target.files[0];

      if (value) {
        const formData = new FormData();
        formData.append("entityName", "booking");
        formData.append("fileTags", "vehicle");
        formData.append("files", value);

        try {
          const response = await fetch(`${apiUrl}/fileapi/upload`, {
            method: "POST",
            body: formData,
          });
          const data = await response.json();
          if (data) {
            toast.success("Image Uploaded successfully.", {
              position: "bottom-center",
              style: {
                background: "blue", // override background
                color: "white",
                fontWeight: "medium",
                marginBottom: "20px",
              },
            });
            setSelectedFile(data?.uploaded);
            settransactiodetails((prev) => ({
              ...prev,
              attachments: data?.uploaded,
            }));
            validateField("attachments", data?.uploaded);
          }
        } catch (error) {
          console.error("Error uploading file:", error);
        }
      }
    } else {
      value = event?.target?.value !== undefined ? event.target.value : event;

      settransactiodetails((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
    validateField(key, value);
  };

  useEffect(() => {
    const { startDate, startTime, endDate, endTime } = inputData;
    if (startDate && startTime && endDate && endTime) {
      const start = new Date(`${inputData.startDate}T${inputData.startTime}`);
      const end = new Date(`${inputData.endDate}T${inputData.endTime}`);

      const diffHours = (end - start) / (1000 * 60 * 60);

      if (diffHours <= 0) {
        toast.error("End time must be after start time", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
        setcostcalulator(null);
        return;
      }

      const isSubscriptionBooking = [
        "dailyRateWeekly",
        "dailyRateFortnightly",
        "dailyRateMonthly",
      ].includes(summaryDetails?.packageSelectedKey);

      if (isSubscriptionBooking && diffHours < 48) {
        toast.error(
          "Subscription bookings can be extended minimum 2 days.",
          {
            position: "bottom-center",
            style: {
              background: "white",
              color: "red",
              fontWeight: "medium",
              marginBottom: "20px",
            },
          },
        );
        setcostcalulator(null);
        setAffectedBookings([]);
        return;
      }

      if (diffHours < 6) {
        toast.error("Extension should be at least 6 hours", {
          position: "bottom-center",
          style: {
            background: "white", // override background
            color: "red",
            fontWeight: "medium",
            marginBottom: "20px",
          },
        });
        setcostcalulator(null);
        return;
      }

      // if (diffHours > 36) {
      //   toast.error("Extension cannot exceed 36 hours", {
      //     position: "bottom-center",
      //     style: {
      //       background: "white", // override background
      //       color: "red",
      //       fontWeight: "medium",
      //       marginBottom: "20px",
      //     },
      //   });
      //   return;
      // }
      setLoading(true);
      getAffectedBookings();
      extensionCostCalculator();
    }
  }, [inputData]);

  function calculateFinalAmount(costcalulator, paymentDetailsData) {
    const weekday = Number(costcalulator?.weekdayRent) || 0;
    const weekend = Number(costcalulator?.weekendRent) || 0;
    const tax = Number(costcalulator?.taxAmount) || 0;

    const discountPercentage =
      Number(paymentDetailsData?.discountPercentage) || 0;

    const total = weekday + weekend;

    // Step 1: Calculate discount value
    const discountValue = Number(
      (total * (discountPercentage / 100)).toFixed(2),
    );

    // Step 2: Remaining amount after applying discount (no negative)
    const remaining = Math.max(total - discountValue, 0);

    const taxCalculation = Number((remaining * 0.18).toFixed(2));

    // Step 3: Add tax
    const finalAmount = Number((remaining + taxCalculation).toFixed(2));

    return { finalAmount, taxCalculation, remaining, discountValue, discountPercentage };
  }

  return (
    <div className="md:p-6">
      <div className="flex items-start justify-between gap-6 mb-8">
        <div>
          <h2 className="text-2xl font-semibold text-[#2c3e50]">
            Booking Extension Process
          </h2>

          <p className="mt-1 text-sm text-gray-500">
            Review the booking details before proceeding with the extension.
          </p>
        </div>

        {(summaryDetails?.packageSelectedKey === "dailyRateWeekly" ||
          summaryDetails?.packageSelectedKey === "dailyRateFortnightly" ||
          summaryDetails?.packageSelectedKey === "dailyRateMonthly") && (
          <div className="flex items-start gap-3 max-w-md px-4 py-3 rounded-xl bg-orange-50 border border-orange-200 shadow-sm">
            <div className="flex-shrink-0 flex items-center justify-center w-8 h-8 rounded-lg bg-orange-100">
              <span className="text-orange-600 text-sm">📝</span>
            </div>

            <div>
              <p className="mt-1 text-xs leading-5 text-orange-700">
                Note: This booking is for a subscription. The booking can be
                extended minimum 2 days.
              </p>
            </div>
          </div>
        )}
      </div>

      <div className="mt-8">
        {/* <h2 className="text-2xl font-bold text-gray-800 mb-6 flex items-center gap-2 border-b-4 pb-2 border-blue-500">
          Extension Booking Details
        </h2> */}
        <div className="grid grid-cols-1 md:grid-cols-4 gap-6 max-w-6xl mx-auto">
          {extensionDetailsInput.map((item, index) => (
            <div key={index} className="flex flex-col mx-auto">
              <label
                htmlFor={item?.value}
                className="text-gray-700 font-medium mb-1"
              >
                {item?.label}
              </label>

              {item.type === "time" ? (
                // Time Dropdown (30-min intervals)
                <select
                  id={item.value}
                  name={item.value}
                  value={inputData[item.value] || ""}
                  onChange={(e) => {
                    setcostcalulator(null);
                    setPaymentTypeErrors("");
                    const { name, value } = e.target;
                    setInputData((prev) => ({
                      ...prev,
                      [name]: value,
                    }));
                  }}
                  disabled={item?.isEnable}
                  className="border border-gray-300 rounded-md px-3 py-1.5 focus:outline-none focus:ring-2 focus:ring-blue-500 text-sm transition h-11 w-full"
                >
                  <option value="">Select time</option>
                  {Array.from({ length: 48 }, (_, i) => {
                    const hours = Math.floor(i / 2);
                    const minutes = i % 2 === 0 ? "00" : "30";
                    const time = `${String(hours).padStart(2, "0")}:${minutes}`;
                    return (
                      <option
                        key={time}
                        value={time}
                        className="py-1 text-sm flex"
                      >
                        {time}
                      </option>
                    );
                  })}
                </select>
              ) : (
                // Normal Input for other types
                <input
                  id={item.value}
                  name={item.value}
                  type={item.type}
                  min={item.value === "endDate" ? inputData.startDate : ""}
                  value={inputData[item.value] || ""}
                  onChange={(e) => {
                    setcostcalulator(null);
                    setPaymentTypeErrors("");
                    const { name, value } = e.target;
                    setInputData((prev) => ({
                      ...prev,
                      [name]: value,
                    }));
                  }}
                  disabled={item?.isEnable}
                  className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition w-full"
                />
              )}

              {/* <input
                id={item.value}
                name={item.value}
                type={item.type}
                value={inputData[item.value] || ""}
                onChange={(e) =>
                  setInputData((prev) => ({
                    ...prev,
                    [item.value]: e.target.value,
                  }))
                }
                disabled={item?.isEnable}
                min={item.value === "endDate" ? inputData.startDate : ""}
                className="border border-gray-300 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 transition"
              /> */}
            </div>
          ))}
        </div>
        {/* <div className="flex justify-end mt-6">
          <button
            onClick={() => {
              if (inputData?.endDate.length && inputData?.endTime.length) {
                const start = new Date(
                  `${inputData.startDate}T${inputData.startTime}`
                );
                const end = new Date(
                  `${inputData.endDate}T${inputData.endTime}`
                );

                const diffHours = (end - start) / (1000 * 60 * 60);

                if (diffHours <= 0) {
                  toast.error("End time must be after start time", {
                    position: "bottom-center",
                    style: {
                      background: "white", // override background
                      color: "red",
                      fontWeight: "medium",
                      marginBottom: "20px",
                    },
                  });
                  return;
                }

                if (diffHours < 6) {
                  toast.error("Extension should be at least 6 hours", {
                    position: "bottom-center",
                    style: {
                      background: "white", // override background
                      color: "red",
                      fontWeight: "medium",
                      marginBottom: "20px",
                    },
                  });
                  return;
                }

                if (diffHours > 36) {
                  toast.error("Extension cannot exceed 36 hours", {
                    position: "bottom-center",
                    style: {
                      background: "white", // override background
                      color: "red",
                      fontWeight: "medium",
                      marginBottom: "20px",
                    },
                  });
                  return;
                }
                setLoading(true);
                getAffectedBookings();
                extensionCostCalculator();
              } else {
                toast.error("Enter End Date and Time");
              }
            }}
            type="submit"
            className="flex gap-2 items-end shadow-xl text-lg bg-gray-50 backdrop-blur-md lg:font-semibold isolation-auto border-gray-50 before:absolute before:w-full before:transition-all before:duration-700 before:hover:w-full before:-left-full before:hover:left-0 before:rounded-full before:bg-emerald-500 hover:text-gray-50 before:-z-10 before:aspect-square before:hover:scale-150 before:hover:duration-700 relative z-10 px-4 py-2 overflow-hidden border-2 rounded-full group"
          >
            Calculate Cost
          </button>
        </div> */}
      </div>

      <div className="mt-12">
        <h2 className="text-xl font-bold text-gray-800 mb-6 flex items-center gap-2">
          Affected Bookings
        </h2>

        <div className="overflow-auto rounded-lg shadow bg-white">
          <table className="min-w-full text-sm text-left shadow-lg border border-gray-100">
            <thead className="">
              <tr>
                <th className="p-4">ID</th>
                <th className="p-4">Booking Code</th>
                <th className="p-4">Book From</th>
                <th className="p-4">Book To</th>
                <th className="p-4">Status</th>
                <th className="p-4 text-right">Ticket Size</th>
              </tr>
            </thead>
            <tbody>
              {affectedBookings?.length > 0 ? (
                affectedBookings.map((data) => (
                  <tr key={data?.id} className="border-b hover:bg-gray-50">
                    <td className="p-4">{data?.id}</td>
                    <td className="p-4">{data?.bookingCode}</td>
                    <td className="p-4">{formatDateAndTime(data?.bookFrom)}</td>
                    <td className="p-4">{formatDateAndTime(data?.bookTo)}</td>
                    <td className="p-4">
                      {fleetBookingStatus[data?.bookingStatus]}
                    </td>
                    <td className="p-4 text-right">
                      {"₹ " + data?.costToCustomer}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="text-center p-4 text-gray-500">
                    No affected bookings found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {loading ? (
        <div className="flex justify-center items-center mt-6">
          <BlinkBlur size={40} color="#3b82f6" />
        </div>
      ) : (
        costcalulator && (
          <>
            <div className="md:p-6 mt-6 bg-gradient-to-br from-green-50 to-green-100 shadow-xl rounded-2xl">
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
                {[
                  {
                    name: "Ext  Start Date",
                    value: inputData?.startDate + "," + inputData?.startTime,
                  },
                  {
                    name: "Exnt End Date",
                    value: inputData?.endDate + "," + inputData?.endTime,
                  },
                  { name: "Vehicle Name", value: summaryDetails?.vehicleName },
                  {
                    name: "Vehicle Registration",
                    value: summaryDetails?.vehicleRegistrationNo,
                  },
                  {
                    name: "Weekday Rent",
                    value: "₹ " + costcalulator?.weekdayRent + ".00",
                  },
                  {
                    name: "Weekend Rent",
                    value: "₹ " + costcalulator?.weekendRent + ".00",
                  },
                  {
                    name: "Weekday Hrs",
                    value: costcalulator?.weekdayHrs + " hrs",
                  },
                  {
                    name: "Weekend Hrs",
                    value: costcalulator?.weekendHrs + " hrs",
                  },
                  {
                    name: "Total Hrs",
                    value: costcalulator?.totalHrs + " hrs",
                  },
                  {
                    name: "Sub Total",
                    value: "₹ " + costcalulator?.baseFare + ".00",
                  },
                  {
                    name: "Total Free Km",
                    value: costcalulator?.totalFreeKms + " kms",
                  },
                  {
                    name: "Discount %",
                    value:
                      calculateFinalAmount(costcalulator, paymentDetailsData)
                        ?.discountPercentage || 0,
                  },
                  {
                    name: "Discount Amount",
                    value:
                      "₹ " +
                      calculateFinalAmount(costcalulator, paymentDetailsData)
                        ?.discountValue.toFixed(2),
                  },
                  {
                    name: "Discount Base Amount",
                    value:
                      "₹ " +
                      calculateFinalAmount(costcalulator, paymentDetailsData)
                        ?.remaining,
                  },
                  {
                    name: "Tax Amount",
                    value:
                      "₹ " +
                      calculateFinalAmount(costcalulator, paymentDetailsData)
                        ?.taxCalculation,
                  },
                  {
                    name: "Previous Pending Rent",
                    value:
                      "₹ " +
                      Number((paymentDetailsData?.pendingAmount).toFixed(2)) +
                      "-",
                  },
                  {
                    name: "Total Rent",
                    value:
                      "₹ " +
                      calculateFinalAmount(costcalulator, paymentDetailsData)
                        ?.finalAmount,
                  },
                ].map(({ name, value }, index) => (
                  <div
                    key={index}
                    className="flex flex-col p-4 bg-white rounded-xl shadow hover:shadow-lg transition-all border border-green-100"
                  >
                    <h3 className="text-sm font-medium text-gray-500">
                      {name}
                    </h3>
                    <p
                      title={value}
                      className="text-lg font-semibold text-gray-800 mt-1 w-66 truncate"
                    >
                      {value || "-"}
                    </p>
                  </div>
                ))}
              </div>
            </div>

            <div className="mt-8">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* <label>Requested By</label>
              <select className="w-92 h-12 p-3 border border-gray-300 rounded-md">
                <option>Select</option>
                <option>Admin</option>
                <option>Customer</option>
              </select> */}
                <label>Payment Collection Type</label>
                <select
                  className="w-92 h-12 p-3 border border-gray-300 rounded-md"
                  value={selectedPaymentType}
                  onChange={(e) => {
                    setSelectedPaymentType(e.target.value);
                    setPaymentTypeErrors("");
                  }}
                >
                  <option value="">Select</option>
                  {Object.entries(paymentCollectionType).map(([key, value]) => {
                    return (
                      <option key={key} value={value}>
                        {value}
                      </option>
                    );
                  })}
                </select>
              </div>
              {paymentTypeErrors && (
                <p className="text-red-500 text-sm mt-1 text-end">
                  {paymentTypeErrors}
                </p>
              )}
            </div>

            {selectedPaymentType === "Pre Paid" ? (
              <>
                <div className="grid grid-cols-1 md:grid-cols-4 p-2 gap-4 my-4">
                  {transactionDetailsInput.map((input, index) => (
                    <div key={index}>
                      {input.type === "file" ? (
                        <>
                          <input
                            type="file"
                            accept="image/*" // or any file type
                            onChange={(e) => handleInputChange(input.value, e)}
                          />
                          {errors[input.value] && (
                            <p className="text-red-500 text-sm mt-1">
                              {errors[input.value]}
                            </p>
                          )}
                        </>
                      ) : (
                        <TextField
                          fullWidth
                          type={input.type}
                          label={input.label}
                          disabled={input?.isEnable}
                          value={transactiondetails[input.value] || ""}
                          onChange={(e) => handleInputChange(input.value, e)}
                          error={!!errors[input.value]}
                          helperText={errors[input.value]}
                          InputLabelProps={{ shrink: true }}
                        />
                      )}
                    </div>
                  ))}
                </div>

                <div className="flex justify-end gap-4">
                  <button
                    onClick={() => {
                      if (hasUnstableConnection) {
                        setPaymentLinkGenerated(false);
                        toast.error(
                          "Please check your network connection. Your internet connection appears to be unstable.",
                          {
                            position: "bottom-center",
                            style: {
                              background: "white", // override background
                              color: "red",
                              fontWeight: "medium",
                              marginBottom: "20px",
                            },
                          },
                        );
                      } else {
                        if (!paymentLinkGenerated) {
                          generatepaymentlink("generate");
                        }
                      }
                    }}
                    class={`${
                      paymentLinkGenerated
                        ? "cursor-not-allowed opacity-50"
                        : "cursor-pointer"
                    } text-white font-bold relative text-[14px] w-[14em] h-[3em] text-center bg-gradient-to-r from-violet-500 from-10% via-sky-500 via-30% to-pink-500 to-90% bg-[length:400%] rounded-[30px] z-10 hover:animate-gradient-xy hover:bg-[length:100%] before:content-[''] before:absolute before:-top-[5px] before:-bottom-[5px] before:-left-[5px] before:-right-[5px] before:bg-gradient-to-r before:from-violet-500 before:from-10% before:via-sky-500 before:via-30% before:to-pink-500 before:bg-[length:400%] before:-z-10 before:rounded-[35px] before:hover:blur-xl before:transition-all before:ease-in-out before:duration-[1s] before:hover:bg-[length:10%] active:bg-violet-700 focus:ring-violet-700 hover:brightness-110 hover:-translate-y-[1px] active:brightness-90 active:translate-y-[2px]`}
                  >
                    + Generate Payment Link
                  </button>

                  <button
                    onClick={handleSave}
                    disabled={
                      ![
                        "transactionid",
                        "transactioncharges",
                        "paymentmode",
                        "payableamount",
                        "paymentremarks",
                        "attachments",
                      ].every(
                        (key) =>
                          transactiondetails[key] !== null &&
                          transactiondetails[key] !== undefined &&
                          transactiondetails[key] !== "",
                      )
                    }
                    className={`relative inline-flex items-center gap-2 px-6 py-3 font-semibold text-teal-50 
      bg-gradient-to-tr from-teal-900/50 via-teal-900/90 to-teal-900/30 ring-4 ring-teal-900/20 
      rounded-full overflow-hidden hover:opacity-90 transition-opacity 
      before:absolute before:top-4 before:left-1/2 before:-translate-x-1/2 
      before:w-[100px] before:h-[100px] before:rounded-full before:bg-gradient-to-b 
      before:from-teal-50/10 before:blur-xl
      ${
        ![
          "transactionid",
          "transactioncharges",
          "paymentmode",
          "payableamount",
          "paymentremarks",
          "attachments",
        ].every(
          (key) =>
            transactiondetails[key] !== null &&
            transactiondetails[key] !== undefined &&
            transactiondetails[key] !== "",
        )
          ? "opacity-50 cursor-not-allowed"
          : ""
      }`}
                  >
                    + Add Payment
                  </button>
                </div>

                {paymentLink && (
                  <div className="mt-8">
                    {/* Slow Network Warning */}
                    {hasUnstableConnection && (
                      <div className="mb-3 flex items-center gap-2 rounded-lg border border-red-200 bg-red-50 px-4 py-3">
                        <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-red-100 text-red-600">
                          <InfoIcon />
                        </div>

                        <div>
                          <p className="text-sm font-semibold text-red-700">
                            Slow Network
                          </p>
                          <p className="text-xs text-red-600">
                            Your network connection is not stable. Please check
                            your internet connection before proceeding.
                          </p>
                        </div>
                      </div>
                    )}

                    {/* Payment Table */}
                    <div
                      className={`overflow-x-auto rounded-lg border shadow-lg ${
                        hasUnstableConnection
                          ? "border-red-200 bg-red-50"
                          : "border-gray-100 bg-white"
                      }`}
                    >
                      <table className="min-w-full text-sm text-left">
                        <thead
                          className={
                            hasUnstableConnection ? "bg-red-100" : "bg-gray-50"
                          }
                        >
                          <tr>
                            <th className="whitespace-nowrap p-4 font-semibold">
                              Payment Id
                            </th>

                            <th className="whitespace-nowrap p-4 font-semibold">
                              Total Amount
                            </th>

                            <th className="whitespace-nowrap p-4 font-semibold">
                              Payment Url
                            </th>

                            <th className="whitespace-nowrap p-4 font-semibold">
                              Status
                            </th>

                            <th className="whitespace-nowrap p-4 font-semibold">
                              Generated At
                            </th>

                            {paymentLink?.status === "captured" ? (
                              <></>
                            ) : (
                              <th className="whitespace-nowrap p-4 text-right font-semibold">
                                Actions
                              </th>
                            )}
                          </tr>
                        </thead>

                        <tbody>
                          {paymentLink ? (
                            <tr
                              key={paymentLink?.id}
                              className={`border-b ${
                                hasUnstableConnection
                                  ? "border-red-200 hover:bg-red-100"
                                  : "border-gray-100 hover:bg-gray-50"
                              }`}
                            >
                              <td className="whitespace-nowrap p-4">
                                {paymentLink?.paymentId}
                              </td>

                              <td className="whitespace-nowrap p-4">
                                {"₹ " + paymentLink?.amount}
                              </td>

                              <td className="p-4">
                                <span className="block max-w-[300px] truncate">
                                  {paymentLink?.shortUrl}
                                </span>
                              </td>

                              <td className="whitespace-nowrap p-4">
                                <span
                                  className={`inline-flex rounded-full px-3 py-1 text-xs font-medium ${
                                    paymentLink?.status === "captured"
                                      ? "bg-green-100 text-green-700"
                                      : "bg-yellow-100 text-yellow-700"
                                  }`}
                                >
                                  {paymentLink?.status}
                                </span>
                              </td>

                              <td className="whitespace-nowrap p-4">
                                {formatDateAndTime(paymentLink?.createdAt)}
                              </td>

                              {paymentLink?.status === "captured" ? (
                                <></>
                              ) : (
                                <td className="p-4 text-right">
                                  <button
                                    type="button"
                                    disabled={paymentLinkGenerated}
                                    onClick={() => {
                                      if (hasUnstableConnection) {
                                        setPaymentLinkGenerated(false);

                                        toast.error(
                                          "Slow Network — Your network connection is not stable. Please check your internet connection.",
                                          {
                                            position: "bottom-center",
                                            style: {
                                              background: "white",
                                              color: "red",
                                              fontWeight: "medium",
                                              marginBottom: "20px",
                                            },
                                          },
                                        );
                                      } else {
                                        if (!paymentLinkGenerated) {
                                          generatepaymentlink("actions");
                                        }
                                      }
                                    }}
                                    className={`inline-flex items-center justify-center rounded-md px-3 py-2 transition ${
                                      paymentLinkGenerated
                                        ? "cursor-not-allowed bg-gray-100 text-gray-400"
                                        : hasUnstableConnection
                                          ? "cursor-pointer bg-red-100 text-red-600 hover:bg-red-200"
                                          : "cursor-pointer bg-gray-100 text-gray-700 hover:bg-gray-200"
                                    }`}
                                  >
                                    <InfoIcon />
                                  </button>
                                </td>
                              )}
                            </tr>
                          ) : (
                            <tr>
                              <td
                                colSpan="6"
                                className="p-4 text-center text-gray-500"
                              >
                                No payment links found.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                {paymentSavedDetails && (
                  <table className="min-w-full text-sm text-left shadow-lg border border-gray-100 mt-8">
                    <thead className="">
                      <tr>
                        <th className="p-4">Transaction Code</th>
                        <th className="p-4">Total Amount</th>
                        <th className="p-4">Payment Mode</th>
                        <th className="p-4">Description</th>
                        <th className="p-4">Generated At</th>
                      </tr>
                    </thead>
                    <tbody>
                      {paymentSavedDetails ? (
                        <tr className="border-b hover:bg-gray-50">
                          <td className="p-4">
                            {paymentSavedDetails?.transactionCode}
                          </td>
                          <td className="p-4">
                            {"₹ " + paymentSavedDetails?.amount}
                          </td>
                          <td className="p-4">
                            {paymentSavedDetails?.paymentMode}
                          </td>
                          <td className="p-4">
                            {paymentSavedDetails?.description}
                          </td>
                          <td className="p-4">
                            {formatDateAndTime(paymentSavedDetails?.createdAt)}
                          </td>
                        </tr>
                      ) : (
                        <tr>
                          <td
                            colSpan="6"
                            className="text-center p-4 text-gray-500"
                          >
                            No payment links found.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                )}

                {(paymentLink?.status === "captured" ||
                  paymentSavedDetails) && (
                  <div className="flex justify-end mt-6">
                    <button
                      onClick={() => {
                        if (!selectedPaymentType) {
                          setPaymentTypeErrors("* Please select payment type");
                          return;
                        } else if (
                          selectedPaymentType !== "Freeze" &&
                          costcalulator?.costToTheCustomer < 0
                        ) {
                          setPaymentTypeErrors(
                            "* Cannot able to Proceed having negative amount",
                          );
                          return;
                        }
                        updateBooking();
                      }}
                      // onClick={updateBooking}
                      className="cursor-pointer bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border border-slate-500 text-white font-medium"
                    >
                      Update Booking
                    </button>
                  </div>
                )}
              </>
            ) : (
              <div className="flex justify-end">
                <button
                  onClick={() => {
                    if (!selectedPaymentType) {
                      setPaymentTypeErrors("* Please select payment type");
                      return;
                    } else if (
                      selectedPaymentType !== "Freeze" &&
                      costcalulator?.costToTheCustomer < 0
                    ) {
                      setPaymentTypeErrors(
                        "* Cannot able to Proceed having negative amount",
                      );
                      return;
                    }
                    updateBooking();
                  }}
                  // onClick={updateBooking}
                  className="cursor-pointer mt-8 bg-gradient-to-b from-indigo-500 to-indigo-600 shadow-[0px_4px_32px_0_rgba(99,102,241,.70)] px-6 py-3 rounded-xl border border-slate-500 text-white font-medium"
                >
                  Update Booking
                </button>
              </div>
            )}
          </>
        )
      )}
    </div>
  );
};

export default Extension;
